import { Injectable, inject } from '@angular/core';
import {
  HttpContextToken,
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';

/** Request context flag: fail silently (no toast) for this call. */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private router = inject(Router);
 private toastr = inject(ToastrService);
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (req.context.get(SKIP_ERROR_TOAST)) return throwError(() => error);
        const message = error.error?.message || 'Something went wrong';
  
        switch (error.status) {
          case 400:
            this.toastr.error(message, 'Validation Error');
            break;
  
          case 401:
            localStorage.clear();
            this.router.navigate(['/login']);
            break;
  
          case 403:
            this.toastr.error('You are not authorized to perform this action.', 'Forbidden');
            break;
  
          case 404:
            this.toastr.warning('The requested resource was not found.', 'Not Found');
            break;
  
          case 500:
            this.toastr.error('Internal server error. Please try again later.', 'Server Error');
            break;
  
          default:
            this.toastr.error(message, 'Error');
        }
  
        return throwError(() => error);
      })
    );
  }
  
}
